import { Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { ReportBaseService } from './report-base.service';

import { UtilsService } from './utils.service';
import { AsnOrders_DatasourceService } from './AsnOrders.datasource.index';

interface IAsnOrders_license_plate_labels_by_order_reportServiceInParams {
  orderId: number}

interface IAsnOrders_license_plate_labels_by_order_reportServiceData {
  LicensePlates?: { result?: { Id?: number, ActualPackagedAmount?: number, ExpectedPackagedAmount?: number, ActualTargetLicensePlate?: { LookupCode?: string }, Lot?: { LookupCode?: string, VendorLot?: { ExpirationDate?: string, LookupCode?: string, ManufactureDate?: string }, Material?: { LookupCode?: string } }, ActualPackagedPack?: { ShortName?: string }, Order?: { LookupCode?: string, Project?: { LookupCode?: string } } }[] }
}

@Injectable({ providedIn: 'root' })
export class AsnOrders_license_plate_labels_by_order_reportService extends ReportBaseService<IAsnOrders_license_plate_labels_by_order_reportServiceInParams, IAsnOrders_license_plate_labels_by_order_reportServiceData> {

  protected reportReferenceName = 'license_plate_labels_by_order_report';
  protected appReferenceName = 'AsnOrders';

  constructor(
    utils: UtilsService,
    private datasources: AsnOrders_DatasourceService,
    ) {
      super(utils);
  }

  override throwIfMissingRequiredInParams (inParams: IAsnOrders_license_plate_labels_by_order_reportServiceInParams) {
  }

  protected async getData(inParams: IAsnOrders_license_plate_labels_by_order_reportServiceInParams): Promise<IAsnOrders_license_plate_labels_by_order_reportServiceData> 
  {
    const $utils = this.utils;
    const $report: { inParams: IAsnOrders_license_plate_labels_by_order_reportServiceInParams } = {
      inParams: inParams
    };

    const data: IAsnOrders_license_plate_labels_by_order_reportServiceData = {
    };
    const datasourcesQueries: (() => Promise<void>)[] = [];

    datasourcesQueries.push(async () => {
      const dsParams = {
        orderId:  $report.inParams.orderId 
      };
      const dsData = await this.datasources.AsnOrders.ds_license_plate_labels_by_order_report.get(dsParams);
      
      data.LicensePlates = dsData;
    });

    await Promise.all(datasourcesQueries.map(t => t()));

    return data;
  }
}
